// fetching schedule
export const FETCH_SCHEDULE = 'fetch_schedule';
export const FETCH_SCHEDULE_LOADING = 'fetch_schedule_loading';
export const FETCH_SCHEDULE_SUCCESS = 'fetch_schedule_success';
export const FETCH_SCHEDULE_FAILED = 'fetch_schedule_failed';

// filtering schedule
export const FILTER_SCHEDULE_LOADING = 'filter_schedule_loading';
export const FILTER_SCHEDULE_SUCCESS = 'filter_schedule_success';
export const FILTER_SCHEDULE_FAILED = 'filter_schedule_failed';
export const ACTIVATE_SCHEDULE_FILTER = 'activate_schedule_filter';

// fetching vods
export const FETCH_VODS = 'fetch_vods';
export const FETCH_VODS_LOADING = 'fetch_vods_loading';
export const FETCH_VODS_SUCCESS = 'fetch_vods_success';
export const FETCH_VODS_FAILED = 'fetch_vods_failed';

// city
export const SET_CURRENT_CITY = 'set_current_city';
